export var ALERT_ENUM;
(function (ALERT_ENUM) {
    ALERT_ENUM["HIGH"] = "HIGH";
    ALERT_ENUM["LOW"] = "LOW";
    ALERT_ENUM["MEDIUM"] = "MEDIUM";
    ALERT_ENUM["OTHERS"] = "(others)";
})(ALERT_ENUM || (ALERT_ENUM = {}));
//# sourceMappingURL=alert.types.js.map